<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="area-container left-area">
            <CommonTree
                ref="faculty_tree"
                type="room"
                :showFilter="true"
                @change="handleNodeClick"
                :customStyle="{ height: 'calc(100vh - 158px)', borderRight: 'none', width: '100%' }"
            />
        </div>
        <div class="data-container center-area">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
                <el-button
                    type="primary"
                    v-permission="['thermostat:device-manage:add']"
                    :icon="Plus"
                    plain
                    @click="onAddClick()"
                >
                    添加
                </el-button>
                <el-button
                    type="primary"
                    :icon="Upload"
                    plain
                    @click="onRemoveClick(selected_ids)"
                    v-permission="['thermostat:device-manage:remove']"
                >
                    批量删除
                </el-button>
                <!-- <el-button @click="uploadVisible = true" :icon="Upload">导入IMEI</el-button> -->
                <el-button @click="uploadVisible2 = true" :icon="Upload" v-permission="['thermostat:device-manage:import']">
                    导入
                </el-button>
                <el-button @click="handleExport" :icon="Upload" v-permission="['thermostat:device-manage:export']">
                    导出
                </el-button>
            </div>
            <el-form class="search-form" ref="search_form" :inline="true" :model="search_params" label-position="top">
                <el-form-item label="名称" prop="name">
                    <el-input style="width: 165px" v-model="search_params.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="状态" prop="online">
                    <el-select v-model="search_params.online" placeholder="请选择状态" style="width: 165px" clearable>
                        <el-option
                            v-for="item in run_statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI" prop="IMEI">
                    <el-input style="width: 165px" placeholder="请输入IMEI" v-model="search_params.IMEI" clearable />
                </el-form-item>
                <el-form-item label="ICCID" prop="ICCID">
                    <el-input style="width: 165px" placeholder="请输入ICCID" v-model="search_params.ICCID" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                @selection-change="handleSelectionChange"
                scrollbar-always-on
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="名称" width="150px" prop="name" align="center"></el-table-column>
                <el-table-column label="设备类型/型号" width="300" prop="device_type" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span>{{ row.model ? model_list[row.model]?.type + '/' + model_list[row.model]?.model : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="风管机型号" width="150px" prop="model_name" align="center"></el-table-column>
                <el-table-column label="IMEI" width="150px" prop="IMEI" align="center"></el-table-column>
                <el-table-column label="状态" width="90" prop="online" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="row.online" type="success">在线</el-tag>
                        <el-tag v-else type="danger">离线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="首次注册时间" width="150px" prop="create_time" align="center"></el-table-column>
                <el-table-column label="版本号" width="150px" prop="version" align="center"></el-table-column>
                <el-table-column label="ICCID" width="200" prop="ICCID" align="center"></el-table-column>
                <el-table-column label="安装位置" min-width="300" prop="location" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span>{{ room_list[row.room] }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right" width="220">
                    <template #default="{ row }">
                        <el-button
                            type="primary"
                            link
                            :icon="View"
                            v-permission="['thermostat:device-manage:detail']"
                            @click="onShowClick(row)"
                        >
                            详情
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            :icon="Edit"
                            @click="onEditClick(row)"
                            v-permission="['thermostat:device-manage:edit']"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="primary"
                            :icon="Delete"
                            link
                            @click="onRemoveClick(row.id)"
                            v-permission="['thermostat:device-manage:remove']"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
            <forms-dialog
                v-if="formDialogVisible"
                v-model="formDialogVisible"
                :isForm="isForm"
                :modelId="selectModelId"
                :detailData="detail_data"
                @updateForm="getTableData"
            />
            <add-forms-dialog v-if="addformDialogVisible" v-model="addformDialogVisible" @updateForm="getTableData" />
            <imports-form
                v-if="uploadVisible"
                v-model="uploadVisible"
                @updateForm="importsComplete"
                menuCode="HVAC/thermostat/imei"
            />
            <imports-form
                v-if="uploadVisible2"
                v-model="uploadVisible2"
                @updateForm="importsComplete"
                menuCode="HVAC/thermostat/detail"
            />
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from 'vue'
import { Delete, Download, Edit, Plus, Refresh, Search, Upload, View } from '@element-plus/icons'
import { addIMEI, deleteDevice, getDeviceList, batchPatch } from '@/api/thermostat/devicePoint.js'
import FormsDialog from './components/forms.vue'
import addFormsDialog from './components/addForms.vue'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'
import ImportsForm2 from '@/components/ImportsForm.vue'
import Pagination from '@/components/Pagination/index.vue'
import CommonTree from '@/components/BuildTree/CommonTree.vue'
import { getOptionTree } from '@/api/room.js'
import { getEquipModelTree } from '@/api/equipment.js'
import Exceljs from 'exceljs'
import FileSaver from 'file-saver'
import { lockOptions, speed, run_mode } from '@/constant/index.js'

// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children & device_type?.children &&
                device_type.children?.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    const room_locations = {}
    function getRoom(list, location) {
        list.forEach((item) => {
            if (item.children) {
                getRoom(item.children, location + '/' + item.name)
            } else {
                room_locations[item.id] = location.slice(1) + '/' + item.name
            }
        })
    }
    await getOptionTree().then((data) => {
        getRoom(data ? data?.[0]?.children : [], '')
        room_list.value = room_locations
    })
}

// 状态列表
const run_statusList = [
    { name: '在线', value: 1 },
    { name: '离线', value: 0 }
]

// 左侧区域树
const faculty_tree = ref(null)
const current_node = ref({})
const handleNodeClick = (data) => {
    current_node.value = data
    resetQueryForm()
}

// 重置
const search_form = ref(null)
const resetQueryForm = () => {
    search_form.value.resetFields()
    getTableData()
}
// 数据源
const search_params = reactive({
    name: '',
    online: null,
    IMEI: '',
    ICCID: '',
    model: ''
})

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    tableLoading.value = true
    const params = { ...search_params, ...page_params }
    if (current_node.value?.id) {
        if (current_node.value?.node_type !== undefined) {
            params.building = current_node.value.id
        } else {
            params.room = current_node.value.id
        }
    }
    try {
        const { lists, total: total_count } = await getDeviceList(params)
        table_data.value = lists
        total.value = total_count
        tableLoading.value = false
    } catch (err) {
        console.log(err)
        tableLoading.value = false
    }
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 表格多选
const selected_ids = ref([])
function handleSelectionChange(list) {
    selected_ids.value = list.map((item) => {
        return item.id
    })
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
const detail_data = ref({})
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectModelId.value = ''
})

// 查看
const onShowClick = (row) => {
    isForm.value = false
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}
// 编辑
const onEditClick = (row) => {
    isForm.value = true
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}
const addformDialogVisible = ref(false)
// 添加
const onAddClick = () => {
    addformDialogVisible.value = true
    // ElMessageBox.prompt('请输入设备IMEI', {
    //     inputPattern: /^\d{15}$/,
    //     inputErrorMessage: '请输入15位数字',
    //     beforeClose: async (action, instance, done) => {
    //         if (action === 'confirm') {
    //             if (instance.inputValue) {
    //                 instance.confirmButtonLoading = true
    //                 addIMEI({
    //                     type: 3,
    //                     IMEI: instance.inputValue
    //                 })
    //                     .then(() => {
    //                         instance.confirmButtonLoading = false
    //                         ElMessage.success('添加成功')
    //                         getTableData()
    //                         done()
    //                     })
    //                     .catch(() => {
    //                         instance.confirmButtonLoading = false
    //                     })
    //             } else {
    //                 ElMessage.error('请输入设备IMEI')
    //                 instance.confirmButtonLoading = false
    //             }
    //         } else {
    //             done()
    //         }
    //     }
    // })
}

// 删除
function onRemoveClick(id) {
    if (typeof id === 'object' && id.length === 0) {
        ElMessage.error('请选择要删除的设备')
        return
    }
    ElMessageBox.confirm('是否确认删除选中的设备？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        if (typeof id === 'object') {
            batchPatch(id).then(() => {
                ElMessage.success('删除成功')
                getTableData()
            })
        } else {
            deleteDevice(id).then(() => {
                ElMessage.success('删除成功')
                getTableData()
            })
        }
    })
}

// 导入
const uploadVisible = ref(false)
const uploadVisible2 = ref(false)
function importsComplete() {
    uploadVisible.value = false
    uploadVisible2.value = false
    faculty_tree.value.getTreeData()
    getTableData()
}

// 导出
const handleExport = async () => {
    ElMessageBox.confirm('是否确认导出设备数据', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const loading = ElLoading.service({
                lock: true,
                text: '正在导出...',
                spinner: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            let list = []
            await getDeviceList({
                page: 1,
                ...search_params,
                page_size: total.value
            }).then((data) => {
                list = data.lists.map((item) => {
                    return {
                        location: item.room ? room_list.value[item.room].split('/') : [],
                        name: item.name,
                        IMEI: item.IMEI,
                        ICCID: item.ICCID
                    }
                })
            })
            if (list.length <= 0) {
                loading.close()
                return ElMessage.error('没有数据可导出')
            }

            // 创建excel并写入数据
            let workbook = null
            workbook = new Exceljs.Workbook()
            workbook.created = new Date()
            workbook.modified = new Date()
            workbook.lastPrinted = new Date()
            const worksheet = workbook.addWorksheet('设备', {
                properties: {
                    defaultRowHeight: 22
                },
                pageSetup: {
                    horizontalCentered: true
                }
            })

            worksheet.columns = [
                {
                    header: '小区',
                    key: 'community',
                    width: 30
                },
                {
                    header: '楼栋',
                    key: 'building',
                    width: 10
                },
                {
                    header: '单元',
                    key: 'unit',
                    width: 10
                },
                {
                    header: '楼层',
                    key: 'floor',
                    width: 10
                },
                {
                    header: '房间',
                    key: 'room',
                    width: 20
                },
                {
                    header: '名称',
                    key: 'name',
                    width: 20
                },
                {
                    header: '设备编号（IMEI）',
                    key: 'IMEI',
                    width: 50
                },
                {
                    header: 'ICCID',
                    key: 'ICCID',
                    width: 50
                }
            ]

            worksheet.addRows(
                list.map((item) => {
                    return {
                        community: item.location[0] ?? '',
                        building: item.location[1] ?? '',
                        unit: item.location[2] ?? '',
                        floor: item.location[3] ?? '',
                        room: item.location[4] ?? '',
                        name: item.name,
                        IMEI: item.IMEI,
                        ICCID: item.ICCID
                    }
                })
            )

            worksheet.getRow(1).alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }

            // 导出excel文件
            await workbook.xlsx.writeBuffer().then((buffer) => {
                const date = new Date()
                const year = date.getFullYear() // 年
                let month = date.getMonth() + 1 // 月
                let day = date.getDate() // 日
                let hour = date.getHours() // 时
                let minutes = date.getMinutes() // 分
                let seconds = date.getSeconds() // 秒
                // 给一位数的数据前面加 “0”
                if (month >= 1 && month <= 9) month = '0' + month
                if (day >= 0 && day <= 9) day = '0' + day
                if (hour >= 0 && hour <= 9) hour = '0' + hour
                if (minutes >= 0 && minutes <= 9) minutes = '0' + minutes
                if (seconds >= 0 && seconds <= 9) seconds = '0' + seconds
                const presentDate = `温控器设备${year}${month}${day}${hour}${minutes}${seconds}`

                // 导出并存储文件
                FileSaver.saveAs(new Blob([buffer]), `${presentDate}.xlsx`)
            })
            loading.close()
        })
        .catch(() => {})
}

// 切换到前台时候执行
onMounted(() => {
    getModelList()
    getRoomTree()
    getTableData()
})
</script>

<style scoped></style>
